/**
 * Geo-Block Interceptor
 *
 * Monkey-patches the global `fetch` so that any API response returning
 * a 403 with { code: "GEO_RESTRICTED" } automatically redirects the
 * user to the /geo-blocked page.
 *
 * Import this module once at app startup (e.g. in main.tsx).
 */

const originalFetch = window.fetch.bind(window);

window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
  const response = await originalFetch(...args);

  // Only inspect 403 responses
  if (response.status === 403) {
    try {
      // Clone so the original body is still consumable by the caller
      const cloned = response.clone();
      const body = await cloned.json();

      if (body?.code === 'GEO_RESTRICTED') {
        console.warn('[GeoBlock] Access denied — redirecting to /geo-blocked');

        // Avoid redirect loops
        if (!window.location.pathname.startsWith('/geo-blocked')) {
          window.location.href = '/geo-blocked';
        }
      }
    } catch {
      // Body wasn't JSON — not a geo-block response, ignore
    }
  }

  return response;
};

export {};
